/**
 * @description 导入所有 pinia 模块，请勿修改。
 */
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import { App } from 'vue'

const pinia = createPinia()
pinia.use(piniaPluginPersist)

export function setupStore(app: App<Element>) {
  app.use(pinia)
}

export default pinia
